import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import { push } from 'connected-react-router';
import actionTypes from 'store/table/actionTypes1';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import { setSituation as setSituationAction } from '../actions';

export function* setSituationGen(payload) {
  const {
    ts, isTrial, selectedBB, gameTable, isBBchanged, isGameTableChanged, ggps,
  } = payload.payload;

  const isPlo5 = sessionStorage.getItem('isPlo5') === 'true';

  const ggpsIsMtt = ggps === 'mtt';
  const ggpsIsHu = ggps === 'hu';

  const defineTs = () => {
    if (ggpsIsMtt) {
      if (isGameTableChanged) {
        return 'mttpot';
      }
      return ts;
    }

    if (ggpsIsHu) {
      return 'hu';
    }

    if (isGameTableChanged) {
      return 'low';
    }

    return ts;
  };

  try {
    const res = yield call(api, {
      method: 'post',
      url: isPlo5 ? URL.PLO5SITUATION : URL.SITUATION,
      data: {
        ts: defineTs(),
        bb: isBBchanged ? selectedBB : '100',
        game: (isPlo5 && !gameTable) ? '6max' : gameTable,
        gg: ggps === 'gg',
      },
    });
    yield put(setSituationAction.success({
      situation: res.data,
      ts,
      selectedBB,
      isTrial,
      isBBchanged,
      isGameTableChanged,
      gameTable,
      ggps,
    }));
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(setSituationAction.error(e.response));
    if ((e.originalMessage || e.message) === 'your subscription does not allow you to use this service') {
      yield put(push('/profile'));
    }
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SET_SITUATION, setSituationGen);
}
